<div class="container batch-posting-shell">

  <h1>{{uploadInServiceVehicleShellTranslations.header}}</h1>
  <div class="visually-hidden" role="alert">{{uploadInServiceVehicleShellTranslations.header}}</div>
  @if (uploadProcessing) {
    <div class="visually-hidden"
    role="alert">{{uploadInServiceVehicleShellTranslations.batchFileBeingProcessedAlert}}</div>
  }

  @if (uploadStep === UploadStatus.UPLOAD) {
    <div class="body pt-4">
      @if (uploadProcessing && fileUploaded) {
        <div class="visually-hidden"
        role="alert">{{uploadInServiceVehicleShellTranslations.batchFileBeingProcessedAlert}}</div>
      }
      @if (uploadProcessing) {
        <app-common-banner
          class="mb-1 banner"
          [bannerConfig]="banner"
          data-test-id="app-batch-posting-shell-e-batch-posting-banner">
        </app-common-banner>
      }
      <p class="mb-1">{{uploadInServiceVehicleShellTranslations.selectText}}</p>
      <ul>
        <li>{{uploadInServiceVehicleShellTranslations.acceptText}}</li>
        <li>{{uploadInServiceVehicleShellTranslations.fileNameText}}</li>
      </ul>
    </div>
    <div class="text-danger fw-bold file-errors">
      @if (fileSizeErrorValue | async) {
        <p>We only accept CSV files up to [10]MB</p>
      }
      @if (fileNameError | async) {
        <p>Make sure your file name contains only letters and numbers, no special characters. Then try your upload again.</p>
      }
      @if (fileTypeError | async) {
        <p>Select a file type to continue.</p>
      }
      @if (fileGeneralError | async) {
        <p>There was a problem uploading your file. Try again.</p>
      }
    </div>
    <div class="file-upload">
      <div class="uploaded-file-name py-3">
        @if (file) {
          <button tabindex="-1" allytmln="Remove File">
            {{fileName}}
            <i tabindex="0" class="close-icon allycon-cancel-fill text-primary" (click)="removeFile()"
              (keypress)="removeFile()" tabindex="0">
              <span _ngcontent-svs-c358="" class="visually-hidden">{{fileName}} select to remove</span>
            </i>
          </button>
        }
      </div>
      <div class="drag-drop">
        <input type="file" class="file-input" id="file-input" aria-label="file-input"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          (change)="onFileSelected($event)" #fileUpload data-test-id="app-batch-posting-shell-e-select-file-input"
          tabindex="-1">
        <button (click)="fileUploadEvent()" class="select-file-button" data-test-id="app-batch-posting-shell-e-select-file-button" allytm-click-tagged="false">
          <img src="assets/icons/plus.svg" alt="Select File to Add" class="icon-plus">
          {{uploadInServiceVehicleShellTranslations.selectFileText}}
        </button>
      </div>
    </div>
    <div class="file-type pt-4">
      <h6 class="fw-bold">{{uploadInServiceVehicleShellTranslations.fileType}}</h6>
    </div>
    <div class="custom-control custom-radio mb-3 mt-3">
      <input class="custom-control-input radio" type="radio" name="fileTypeDefault" id="batchFile" value="BATCH_FILE"
        (change)="fileTypeSelection($event)" data-test-id="app-batch-posting-shell-e-file-type-batch-radio-button"
        [attr.aria-label]="uploadInServiceVehicleShellTranslations.batchText" [(ngModel)]="isFileTypeSelected">
      <div class="custom-control-label radio-with-aggregation ms-2">
        <label class="form-check-label" for="BATCH_FILE">
          {{uploadInServiceVehicleShellTranslations.batchText}}
        </label>
      </div>
    </div>
    <div class="custom-control custom-radio mb-3 mt-3">
      <input class="custom-control-input radio" type="radio" name="fileTypeDefault" id="onDemandFile"
        value="ON_DEMAND_FILE"
        (change)="fileTypeSelection($event)"
        data-test-id="app-batch-posting-shell-e-file-type-on-demand-radio-button"
        [attr.aria-label]="uploadInServiceVehicleShellTranslations.onDemandText"
        [(ngModel)]="isFileTypeSelected"
        >
      <div class="custom-control-label radio-with-aggregation ms-2">
        <label class="form-check-label" for="ON_DEMAND_FILE">
          {{uploadInServiceVehicleShellTranslations.onDemandText}}
        </label>
      </div>
    </div>
    <div class="py-3">
      @if (!uploadingFile) {
        <button
          (click)="uploadFile(fileUpload.files[0])"
          allytm-click-tagged="false"
          data-test-id="app-batch-posting-shell-e-upload-button"
          class="upload-button">
          {{uploadInServiceVehicleShellTranslations.uploadText}}
        </button>
      } @else {
        <app-spinner></app-spinner>
      }
    </div>
  }
  @if (uploadStep === UploadStatus.SUCCESS_UPLOADED) {
    <div class="statusUploadSuccess body pt-4 d-flex flex-column align-items-start">
      <p class="m-0">{{uploadInServiceVehicleShellTranslations.statusSuccessTextTop}}</p>
      <button (click)="backToUploadStatus()" class="upload-button my-5"
        data-test-id="app-batch-posting-shell-e-upload-another-file-button">
        {{uploadInServiceVehicleShellTranslations.statusSuccessButtonText}}
      </button>
      <p class="m-0 fst-italic opacity-75">{{uploadInServiceVehicleShellTranslations.statusSuccessNoteText}}</p>
    </div>
  }



  <ng-template #statusUploadSuccess>
    <div class="statusUploadSuccess body pt-4 d-flex flex-column align-items-start">
      <p class="m-0">{{uploadInServiceVehicleShellTranslations.statusSuccessTextTop}}</p>
      <button (click)="backToUploadStatus()" class="upload-button my-5"
        data-test-id="app-batch-posting-shell-e-upload-another-file-button">
        {{uploadInServiceVehicleShellTranslations.statusSuccessButtonText}}
      </button>
      <p class="m-0 fst-italic opacity-75">{{uploadInServiceVehicleShellTranslations.statusSuccessNoteText}}</p>
    </div>
  </ng-template>
  <app-error-modal></app-error-modal>

</div>
